module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: ["dof-diamond-tab"],
    on: {
      "touchend": _vm.touchEnd
    }
  }, [_c('div', {
    class: ['dof-diamond-tab-box', _vm.isFlexible && 'flex-1'],
    style: {
      borderRadius: _vm.borderRadius
    }
  }, _vm._l((_vm._tabData), function(tab, i) {
    return _c('div', {
      key: i,
      class: ['dof-diamond-tab-item', _vm.isFlexible && 'flex-1'],
      style: {
        left: -i + 'px'
      },
      on: {
        "click": function($event) {
          _vm.clickTabItem(i)
        },
        "touchstart": function($event) {
          _vm.touchTabItem(i)
        }
      }
    }, [_c('div', {
      class: [
        'dof-diamond-tab-item-label',
        i === 0 ? 'first-tab' : '',
        i === _vm.dataLen - 1 ? 'last-tab' : '',
        _vm.isFlexible && 'flex-1'
      ],
      style: {
        'border-color': _vm.tabActive === i ? _vm.activeBorderColor : _vm.borderColor,
        'background-color': _vm.touchActive === i ? _vm.touchColor : _vm.bgColor,
        height: _vm.itemHeight + 'px',
        'border-top-left-radius': i === 0 ? _vm.borderRadius : '0px',
        'border-bottom-left-radius': i === 0 ? _vm.borderRadius : '0px',
        'border-top-right-radius': i === _vm.dataLen - 1 ? _vm.borderRadius : '0px',
        'border-bottom-right-radius': i === _vm.dataLen - 1 ? _vm.borderRadius : '0px'
      }
    }, [_c('text', {
      staticClass: ["label-text"],
      style: {
        fontSize: _vm.textFontSize,
        color: _vm.tabActive === i || _vm.touchActive === i ? _vm.activeTextColor : _vm.textColor
      }
    }, [_vm._v(_vm._s(tab.label.length > _vm.labelMaxLen ? tab.label.slice(0, _vm.labelMaxLen) + '...' : tab.label))])]), (i !== _vm.dataLen - 1) ? _c('div', {
      staticClass: ["tabLine"],
      style: Object.assign({
          backgroundColor: _vm.bgColor
        },
        _vm.tabLineStyle
      )
    }, [_c('div', {
      staticClass: ["tabLineMaskDown"],
      style: Object.assign({
          'background-color': _vm.touchActive - 1 === i ? _vm.touchColor : _vm.bgColor
        },
        _vm.maskStyle
      )
    }), _c('div', {
      staticClass: ["tabLineMaskUp"],
      style: Object.assign({
          'background-color': _vm.touchActive === i ? _vm.touchColor : _vm.bgColor
        },
        _vm.maskStyle
      )
    }), _c('div', {
      staticClass: ["border-top"],
      style: {
        'border-color': _vm.tabActive === i ? _vm.activeBorderColor : _vm.borderColor
        // 优化边缘显示
        // width: tabActive - 1 === i ? itemHeight / 4 - 1 + 'px' : itemHeight / 4 + 3 + 'px'
      }
    }), _c('div', {
      staticClass: ["border-bottom"],
      style: Object.assign({
          'background-color': _vm.tabActive - 1 === i ? _vm.activeBorderColor : _vm.borderColor
        }
        // fakeBorderStyle
      )
    }), _c('div', {
      staticClass: ["slash"],
      style: {
        left: _vm.isAndroid ? (_vm.itemHeight / 8) : (_vm.itemHeight / 8 - 1) + 'px',
        transform: _vm.isAndroid ? 'translateX(-1px) rotate(13deg)' : 'rotate(13deg)',
        width: _vm.isAndroid ? '2.5px' : '2px',
        'background-color': _vm.tabActive === i || _vm.tabActive - 1 === i ? _vm.activeBorderColor : 'transparent'
      }
    })]) : _vm._e()])
  }))])
},staticRenderFns: []}
module.exports.render._withStripped = true


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/template-compiler.js?id=data-v-aeb2a70e!./~/weex-vue-loader/lib/selector.js?type=template&index=0!./packages/dof-diamond-tab/index.vue
// module id = 657
// module chunks = 0 1